<div class="container-fluid pricing-container">
  <span>
    <p class="font-header"></p>
  </span>
  <ng-container>
    <div class="row">
      <h2 class="mega-pricing-update">Mega Pricing Update - {{ megaTypeDesc }}.</h2>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega-pricing-update-text">
        <ng-container *ngIf="!isEditMegaFlow">
          <p>
            By booking this Mega, the pricing for this and any Megas scheduled to settle during the
            same month may change. Pricing changes will not go into effect until the Mega has been
            commited. Please review the details below and click “ACCEPT” to accept the updated
            pricing.
          </p>
        </ng-container>
        <ng-container *ngIf="isEditMegaFlow">
          <p>
            By editing this Mega, the pricing for this and any Megas scheduled to settle during the
            same month may change. Pricing changes will not go into effect until the Mega has been
            commited. Please review the details below and click “ACCEPT” to accept the updated
            pricing.
          </p>
        </ng-container>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
        <div class="line-break-1"></div>
      </div>
    </div>
  </ng-container>

  <div class="fm-cdx-table table-pricing">
    <table
      class="fm-cdx-table__static"
      *ngFor="let calcFee of calcFeeRes.megaPricingInfo; trackBy: trackByIdentity"
    >
      <tr>
        <td colspan="5">
          <table class="fm-cdx-table__static">
            <tr class="th_row" *ngIf="!isSFFIXMega">
              <th class="th_column pricing-table-main-head width-20">Month</th>
              <th class="th_column pricing-table-main-head width-25">Current Volume</th>
              <th class="th_column pricing-table-main-head pl-20 width-30">Volume after Commit</th>
              <th class="th_column pricing-table-main-head text-end width-15">Updated Fee</th>
            </tr>
            <tr class="th_row" *ngIf="isSFFIXMega">
              <th class="th_column pricing-table-main-head width-sff-25">Month</th>
              <th class="th_column pricing-table-main-head width-25">Current Volume</th>
              <th class="th_column pricing-table-main-head pl-20 width-sff-30">
                Volume after Commit
              </th>
            </tr>

            <tbody>
              <tr *ngIf="!isSFFIXMega">
                <th class="th_column pricing-table-main-body">
                  {{ calcFee?.pricingMonth | date: 'MMM. yyyy' }}
                </th>
                <th class="th_column pricing-table-main-body">
                  {{ calcFee?.currentVolume | currency: 'USD' : 'symbol' : '1.2-2' }}
                </th>
                <th class="th_column pricing-table-main-body pl-20">
                  {{ calcFee?.newVolume | currency: 'USD' : 'symbol' : '1.2-2' }}
                </th>
                <ng-container
                  *ngIf="calcFee.feeTicks === null && calcFee.feeDollars === null && isEditMegaFlow"
                >
                  <th class="th_column pricing-table-main-body text-end text-center">-</th>
                </ng-container>
                <ng-container *ngIf="calcFee.feeTicks !== null">
                  <th class="th_column pricing-table-main-body text-end update-fee-color">
                    {{ calcFee?.feeTicks | number: '1.3-3' }}/32
                  </th>
                </ng-container>
                <ng-container *ngIf="calcFee.feeDollars !== null">
                  <th class="th_column pricing-table-main-body text-end update-fee-color">
                    <span> <i class="font-cir fa-circle status-icon--sm legend-align"></i> </span
                    >{{ calcFee?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                  </th>
                </ng-container>
              </tr>
              <tr *ngIf="isSFFIXMega">
                <th class="th_column pricing-table-main-body">
                  {{ calcFee?.pricingMonth | date: 'MMM. yyyy' }}
                </th>
                <th class="th_column pricing-table-main-body">
                  {{ calcFee?.currentVolume | currency: 'USD' : 'symbol' : '1.2-2' }}
                </th>
                <th class="th_column pricing-table-main-body pl-sff-20">
                  {{ calcFee?.newVolume | currency: 'USD' : 'symbol' : '1.2-2' }}
                </th>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>

      <tbody>
        <tr class="th_row pricing-table-sub-heading">
          <th class="th_column pricing-table-sub-heading-body-header text-start p-10 width-16">
            MEGA #
          </th>
          <th class="th_column pricing-table-sub-heading-body-header text-end p-12 width-24">
            DEAL AMOUNT
          </th>
          <th class="th_column pricing-table-sub-heading-body-header width-20">SETTLEMENT</th>
          <th class="th_column pricing-table-sub-heading-body-header text-end p-12 width-20">
            PREVIOUS FEE
          </th>
          <th class="th_column pricing-table-sub-heading-body-header text-end p-5 width-20">
            NEW FEE
          </th>
        </tr>
        <tr
          class="td_row pricing-table-sub-heading-body"
          *ngFor="let detail of calcFee.megaList; trackBy: trackByIdentity"
          [ngClass]="
            detail.thisMega === true || detail?.poolNumber === 'THIS MEGA' ? 'thismega-row' : ''
          "
        >
          <ng-container *ngIf="detail.thisMega === true">
            <td class="td_cell pricing-table-sub-heading-body-content mega-pricing-this-mega p-10">
              this mega
            </td>
          </ng-container>
          <ng-container *ngIf="detail.thisMega === false">
            <td class="td_cell pricing-table-sub-heading-body-content p-10">
              {{ detail?.poolNumber }}
            </td>
          </ng-container>
          <td class="td_cell pricing-table-sub-heading-body-content text-end p-12">
            {{ detail?.tradeAmount | currency: 'USD' : 'symbol' : '1.2-2' }}
          </td>
          <td class="td_cell pricing-table-sub-heading-body-content p-12">
            {{ detail?.tradeSettlementDate | date: 'MM/dd/yyyy' }}
          </td>
          <ng-container *ngIf="detail.prevFeeTicks !== null">
            <td class="td_cell pricing-table-sub-heading-body-content text-end p-12">
              {{ detail?.prevFeeTicks | number: '1.3-3' }}/32
            </td>
          </ng-container>
          <ng-container *ngIf="detail.prevFeeDollars !== null">
            <td class="td_cell pricing-table-sub-heading-body-content text-end p-12">
              {{ detail?.prevFeeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
          </ng-container>
          <ng-container *ngIf="detail.prevFeeTicks == null && detail.prevFeeDollars == null">
            <td class="td_cell pricing-table-sub-heading-body-content text-center p-12">-</td>
          </ng-container>
          <ng-container *ngIf="detail.newFeeTicks !== null">
            <td
              class="td_cell pricing-table-sub-heading-body-content text-end p-5"
              [ngClass]="
                detail.thisMega === true || detail?.poolNumber === 'THIS MEGA'
                  ? ''
                  : 'updated-fee-bgcolor'
              "
            >
              <span *ngIf="detail.isSettled === true">
                <i class="font-triangle fa-caret-up status-icon--lg legend-align"></i>
              </span>
              <span *ngIf="detail.isSettled === true && detail.isFixedFee === true"
                >&nbsp;&nbsp;&nbsp;&nbsp;</span
              >
              <span *ngIf="detail.isFixedFee === true">
                <i class="font-square fa-square status-icon--sm legend-align"></i>
              </span>
              {{ detail.newFeeTicks | number: '1.3-3' }}/32
            </td>
          </ng-container>
          <ng-container *ngIf="detail.newFeeDollars !== null">
            <td
              class="td_cell pricing-table-sub-heading-body-content text-end p-5"
              [ngClass]="
                detail.thisMega === true || detail?.poolNumber === 'THIS MEGA'
                  ? ''
                  : 'updated-fee-bgcolor'
              "
            >
              <span *ngIf="detail.isMinFee === true">
                <i class="font-cir fa-circle status-icon--sm legend-align"></i>
              </span>
              {{ detail?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>

    <div class="fee-schedule">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
          <p class="legend-fee legend-minimum-fee">
            <span>
              <ng-container>
                <i class="font-cir fa-circle status-icon--sm"></i> </ng-container></span
            >fees cannot be less than the minimum
          </p>
          <p class="legend-fee">
            <span>
              <ng-container>
                <i class="font-triangle fa-caret-up status-icon--lg"></i> </ng-container></span
            >fees cannot be changed on settled Megas
          </p>
          <br />
          <p class="legend-fee legend-fixed-fee">
            <span>
              <ng-container>
                <i class="font-square fa-square status-icon--sm"></i> </ng-container></span
            >fixed fees
          </p>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
          <button
            class="button fm-primary-button button-accept"
            (click)="closeFeeSheduleModelWindow()"
          >
            ACCEPT
          </button>
          <button class="button fm-tertiary-button button-edit-mega" (click)="editMega()">
            Edit Mega
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
